import { Controller } from '@hotwired/stimulus';

// Detects user timezone on page load and sets it as a cookie.
// Rails reads this cookie to display dates in the user's local time.
//
// Usage: <body data-controller="timezone">
export default class extends Controller {
  connect() {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && document.cookie.indexOf(`timezone=${tz}`) === -1) {
      document.cookie = `timezone=${tz};path=/;max-age=31536000;SameSite=Lax`;
    }
  }
}
